import { Badge } from '@atlas/ui-primitives'
import { useLocation } from 'react-router-dom'
import { NAV_MODULES } from '@/config/nav'

/**
 * Shared "coming soon" screen for §7 modules that appear in the nav but aren't
 * built in this change (design §8.15). Keeps the full information architecture
 * navigable so the product shape reads even where the module is a stub.
 */
export function PlaceholderPage() {
	const { pathname } = useLocation()
	const module = NAV_MODULES.find((m) => m.to === pathname)
	const label = module?.label ?? 'Module'

	return (
		<div className="flex flex-col items-center justify-center py-24 text-center">
			<Badge variant="muted" size="sm" className="mb-3 font-mono uppercase tracking-wide">
				Coming soon
			</Badge>
			<h1 className="text-ds-3xl font-semibold text-ds-text">{label}</h1>
			<p className="mt-2 max-w-md text-ds-text-muted">
				This module is part of the ATLAS design and will be built in a later stage. The navigation and information
				architecture are in place so the product shape is reviewable today.
			</p>
		</div>
	)
}
